import { ArtifactEffectDemo } from '@/components/artifacts/demo/ArtifactEffectDemo';
import { useArtifactContext } from '@/pages/artifacts/useArtifactContext';
import { Skeleton } from '@startupquickstart/frontend';

export function ArtifactDemoTab() {
  const { artifact, isLoading } = useArtifactContext();

  if (isLoading) {
    return (
      <div className="grid gap-6 lg:grid-cols-[minmax(0,20rem)_1fr]">
        <Skeleton className="h-[520px] rounded-[2.2rem]" />
        <Skeleton className="h-64 rounded-xl" />
      </div>
    );
  }

  if (!artifact) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Artifact not found</p>
      </div>
    );
  }

  return <ArtifactEffectDemo artifact={artifact} />;
}
